import React from 'react';
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import importedStyles from './FirstLoginOnBoard.module.sass';
import connect from "react-redux/es/connect/connect";
import Lottie from "react-lottie";
import uploadFiles from "../../animations/uploadFiles"
import {Typography} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CamaraIcon from "@material-ui/icons/Videocam";
import IconButton from "@material-ui/core/IconButton";
import {closeFirstLoginModal} from "./Redux/FirstLoginOnBoardActions";
import history from "../../helpers/history";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import ReactImageAppear from "react-image-appear";


class FirstLoginOnBoard extends React.Component {

    state = {
        actualStep: 1,
        testOpen: true,
        webpAllowed: true,
    };


    componentDidMount = async () => {
        if (!await this.supportsWebp()) {
            this.setState({webpAllowed: false});
        }
    };

    supportsWebp = async() => {
        if (!window.self.createImageBitmap) return false;
        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const blob = await fetch(webpData).then(r => r.blob());
        return createImageBitmap(blob).then(() => true, () => false);
    };

    onDialogOpen = () => {
        ReactPixel.trackCustom('onBoardingOpen');
        ReactGA.ga('send', 'event', 'onBoarding', 'onBoardingOpen');
    };

    onDialogClose = () => {
        ReactPixel.trackCustom('onBoardingClosed');
        ReactGA.ga('send', 'event', 'onBoarding', 'onBoardingClosed');
        this.props.dispatch(closeFirstLoginModal());
    };

    onCTAClick = () => {
        ReactPixel.trackCustom('onBoardingCTAClick');
        ReactGA.ga('send', 'event', 'onBoarding', 'onBoardingCTAClick');
        this.props.dispatch(closeFirstLoginModal());
        history.push('/uploadVideo');
    };


    handleNextStep = () => {
        this.setState({actualStep: this.state.actualStep + 1})
    };

    renderAnimation = () => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: uploadFiles,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return (
            <Lottie options={defaultOptions}
                    height={200}
                    width={200}
                    speed={0.5}
            />
        )
    };



    renderCover(src, name) {
        return (
            <div className={importedStyles.cover}>
                {/*<img src={src} alt={name} className={importedStyles.coverImg} />*/}
                <ReactImageAppear
                    key={name + (this.state.webpAllowed ? 'webp' : 'jpg')}
                    src={src + (this.state.webpAllowed ? '.webp' : '.jpg')}
                    alt={name}
                    //animation="blurIn"
                    loader={'img/loading.gif'}
                    // placeholderClass={importedStyles.coverImg}
                    // placeholder={'/img/png/thumbnail.png'}
                    animationDuration="300ms"
                    className={importedStyles.coverImg}
                />
                <div className={importedStyles.coverNameContainer}>
                    <CamaraIcon style={{
                        color: '#fff', filter: 'drop-shadow(1px 2px 3px black)'
                    }}/>
                    <p className={importedStyles.coverName}>{name}</p>
                </div>
            </div>
        )
    };

    getBackgroundColor = () => {
        switch (this.state.actualStep) {
            case 2:
                return importedStyles.backPrimaryColor;
            case 3:
                return importedStyles.backBlueColor;
            default:
                return null;
        }
    };

    renderDialogContent = () => {
        // eslint-disable-next-line default-case
        switch (this.state.actualStep) {
            case 1:
                return this.renderHello();
            case 2:
                return this.renderYourVideos();
            case 3:
                return this.renderEntities();
            case 4:
                return this.renderReady();
        }
    };

    renderHello() {
        return (
            <>
                <DialogContent className={importedStyles.dialogContent}>
                    {this.renderCover('/img/onBoarding/onboard1small', 'Manel Carrera')}
                    <DialogContentText className={importedStyles.dialogContentText}>
                        <Typography className={importedStyles.congratulations}>Te damos la bienvenida a
                            Grábalo</Typography>
                        <Typography className={importedStyles.selledVideoCopy}>La app
                            donde puedes ganar dinero y premios con tus vídeos amateurs de experiencias reales.
                            ¡Consigue mucho más que
                            likes!</Typography>
                    </DialogContentText>

                </DialogContent>
                <DialogActions className={importedStyles.dialogActions}>
                    <Button fullWidth className={[importedStyles.showLogroButton, importedStyles.backPrimaryColor]}
                            onClick={this.handleNextStep}>
                        Siguiente
                    </Button>
                </DialogActions>
            </>
        );
    }

    renderYourVideos() {
        return (
            <>
                <DialogContent className={[importedStyles.dialogContent, importedStyles.backPrimaryColor]}>
                    {this.renderCover('/img/onBoarding/onboard2small', 'Claraneb')}
                    <DialogContentText className={importedStyles.dialogContentText}>
                        <Typography className={[importedStyles.congratulations, importedStyles.whiteColor]}>Comparte con
                            el mundo vídeos grabados por ti</Typography>
                        <Typography className={[importedStyles.selledVideoCopy, importedStyles.whiteColor]}>Sube vídeos
                            de turismo, deportes,
                            paisajes, divertidos... Comparte tus vídeos originales desde el ordenador o
                            móvil.</Typography>
                    </DialogContentText>

                </DialogContent>
                <DialogActions className={[importedStyles.dialogActions, importedStyles.backPrimaryColor]}>
                    <Button fullWidth className={[importedStyles.showLogroButton, importedStyles.primaryColor]}
                            onClick={this.handleNextStep}>
                        Continuar
                    </Button>
                </DialogActions>
            </>
        );
    }

    renderEntities() {
        return (
            <>
                <DialogContent className={[importedStyles.dialogContent, importedStyles.backBlueColor]}>
                    {this.renderCover('/img/onBoarding/onboard3small', 'Thomas Rich')}
                    <DialogContentText className={importedStyles.dialogContentText}>
                        <Typography className={[importedStyles.congratulations, importedStyles.whiteColor]}>Las marcas
                            necesitan tu talento</Typography>
                        <Typography className={[importedStyles.selledVideoCopy, importedStyles.whiteColor]}>Las marcas
                            asociadas a Grábalo buscan vídeos para comprar.
                            También crean retos para conseguir vídeos. ¡Súbelos y participa!</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={[importedStyles.dialogActions, importedStyles.backBlueColor]}>
                    <Button fullWidth className={[importedStyles.showLogroButton, importedStyles.blueColor]}
                            onClick={this.handleNextStep}>
                        Siguiente
                    </Button>
                </DialogActions>
            </>
        );
    }

    renderReady() {
        return (
            <>
                <IconButton className={importedStyles.closeModalIcon} onClick={this.onDialogClose}>
                    <CloseIcon/>
                </IconButton>

                <DialogContent className={[importedStyles.dialogContent, importedStyles.backBlueColorLight]}>
                    {this.renderCover('/img/onBoarding/onboard4small', 'IsisFeliz3')}
                    <DialogContentText className={importedStyles.dialogContentText}>
                        <Typography className={importedStyles.congratulations}>
                            Sube el primer vídeo y demuestra lo que vales
                        </Typography>
                        <Typography className={importedStyles.selledVideoCopy}>Estás a muy
                            pocos clicks de empezar a triunfar con tus vídeos. Compártelos y muéstrale al mundo de lo
                            que eres capaz.</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={[importedStyles.dialogActions, importedStyles.backBlueColorLight]}>
                    <Button fullWidth className={[importedStyles.showLogroButton, importedStyles.backBlueColor4]}
                            onClick={this.onCTAClick}>
                        Vamos
                    </Button>
                </DialogActions>
            </>
        );
    }

    render() {
        let fullScreen = window.matchMedia("(max-width: 768px)").matches;
        let rootClassnames = importedStyles.dialogRoot + ' ' + this.getBackgroundColor();
        return (
            <Dialog
                open={this.props.open}
                onEntered={this.onDialogOpen}
                disableBackdropClick
                scroll={"body"}
                maxWidth={"xs"}
                fullWidth
                aria-labelledby="first login onboard modal"
                style={{zIndex: 5000}}
                fullScreen={fullScreen}
                classes={{
                    paper: rootClassnames,
                    paperFullScreen: importedStyles.dialogMobileFullScreen,
                }}
                BackdropProps={{
                    className: importedStyles.dialogBackdrop
                }}
            >
                {this.renderDialogContent()}

            </Dialog>
        );

    }
}

const mapStateToProps = ({authReducer, FirstLoginOnBoardReducer}) => {
    return ({
        open: FirstLoginOnBoardReducer.open,
        user: authReducer.user,
        logged: authReducer.logged,
    });
};
export default connect(mapStateToProps)(FirstLoginOnBoard);
